<template>
	<iframe src="https://facedub.developerhub.io/facedub/frequently-asked-questions" frameborder="0" style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"></iframe>
</template>

<script>
export default {
	mounted: function() 
    {
        window.analytics.page('Help');
	}
}
</script>

<style scoped>

</style>
